export const createArrayOfNumberProvided = (number) => {
  return Array.from({ length: number }, (v, i) => i - 1);
};
